/**
 * Created by Yangxunwu on 2018/6/7.
 */

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* 页面布局 */
import Layout from '@/views/layout/Layout'
import BaseLayout from '@/views/layout/BaseLayout'

export default new Router({

	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('@/views/home/index'),
		},
		{
			path: '/staffSalary/:staffId/:staffSalaryUid',
			component: () => import('@/views/salary/salaryDetail'),
			props: true,
			meta: { needAuth: false }
		},
		{
			path: '/account',
			redirect: '/account/login'
		},
		{
			path: '/account/:tab',
			component: () => import('@/views/login/index'),
			props: true,
		},
		{
			path: '/finishRegister',
			component: () => import('@/views/login/finishRegister')
		},
        {
        	path: '/logout',
	        component: () => import('@/views/account/logout')
        },
		{
			path: '/salary',
			component: Layout,
			redirect: '/salary/new',
			children: [
				{
					path: 'new',
					component: () => import('@/views/salary/new'),
					name: 'new',
					meta: { title: 'new', nav: "/salary/new" },
				},
				{
					path: 'checkup/:recordId',
					props: true,
					component: () => import('@/views/salary/checkup'),
					name: 'checkup',
					meta: { title: 'checkup', nav: '/salary/new' },
				},
				{
					path: 'sendPreview/:recordId',
					props: true,
					component: () => import('@/views/salary/sendPreview'),
					name: 'sendPreview',
					meta: { title: 'send', nav: '/salary/new' },
				},
				{
					path: 'sendSuccess',
					component: () => import('@/views/salary/sendSuccess'),
					name: 'sendSuccess',
					meta: { title: 'sendSuccess', nav: '/salary/new' },
				},
				{
					path: 'records',
					component: () => import('@/views/salary/records'),
					name: 'records',
					meta: { title: 'records', nav: '/salary/records' },
				},
				{
					path: 'records/:recordId',
					component: () => import('@/views/salary/records'),
					props: true,
					name: 'recordsWithId',
					meta: { title: 'records', nav: '/salary/records' },
				},
				{
					path: 'records/:recordId/:staffId',
					component: () => import('@/views/salary/records'),
					props: true,
					name: 'recordsWithIdAndStaffId',
					meta: { title: 'records', nav: '/salary/records' },
				},
				{
					path: 'message',
					component: () => import('@/views/message/message'),
					name: 'message',
					meta: { title: 'message', nav: '/salary/message' }
				},
				{
					path: 'help',
					component: () => import('@/views/salary/help'),
					name: 'help',
					meta: { title: 'help', nav: '/salary/help' },
				},
				{
					path: 'detail',
					component: () => import('@/views/salary/helpDetail'),
					name: 'helpDetail',
					meta: { title: 'help', nav: '/salary/help' },
					props: true
				},
				//账户设置
				{
					path: 'account',
					component: () => import('@/views/account/setting'),
					name: 'account',
					meta: { title: 'account' },
				},
				//工资成本分析
				{
					path: 'analytic',
					component: () => import('@/views/analytic/index'),
					name: 'analytic',
					meta: { title: 'analytic', nav: "/salary/analytic" },
				},
			]
		},
		{
			path: '/price',
			component: () => import('@/views/price/price'),
			name: 'price',
			meta: { title: 'price' }
		},
		{
			path: '/qywx',
			redirect: '/qywx/index',
			component: BaseLayout,
			children: [
				{
					path: 'index',
					component: () => import('@/views/qywx/index'),
					name: 'index',
					meta: { title: 'index', needAuth: false },
				},
				{
					path: 'installing/:authCode',
					component: () => import('@/views/qywx/installing'),
					name: 'installing',
					props: true,
					meta: { title: 'installing', needAuth: false },
				},
				{
					path: 'install-failed',
					component: () => import('@/views/qywx/installFailed'),
					name: 'installFailed',
					meta: { title: 'installFailed', needAuth: false },
				},
				{
					path: 'sso-logging/:authCode',
					component: () => import('@/views/qywx/ssoLogging'),
					name: 'ssoLogging',
					props: true,
					meta: { title: 'ssoLogging', needAuth: false },
				},
			]
		},
		{ path: '*', component: () => import('@/views/error/404') },
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js